<div class="wo-notification-warning"
     [class.wo-notification-warning--critical]="severity === 'critical'"
     [class.wo-notification-warning--info]="severity === 'wait'"
>
  <iss-icon [name]="icon" class="wo-notification-warning__icon"/>
  <div class="wo-notification-warning-text">
    <ng-content/>
  </div>
</div>
